import { useEffect } from 'react';

import { useQuery } from 'react-query';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';

import { API_URL } from 'api/API';
import getServerTimeApi from 'api/common/getServerTimeApi';

import { dateTimeState } from 'libs/atoms';
import { convertDateTime } from 'libs/utils';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DateBox = styled.div`
  display: flex;
  gap: 8px;
`;

const TimeZone = styled.span`
  color: #85cde5;
  font-size: 11px;
  position: relative;
  top: 2px;
`;

const SDate = styled.span`
  font-weight: 500;
`;

const Time = styled.span`
  display: block;
  width: 80px;
`;

const Clock = () => {
  const [dateTime, setDateTime] = useRecoilState(dateTimeState);
  const { data } = useQuery([API_URL.COMMON.GET_SERVER_TIME], getServerTimeApi, {
    refetchInterval: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!data?.date || !data?.time) return;
    const date = new Date(`${data.date.replaceAll('-', '/')} ${data.time}`);

    function updateDateTime(add: 0 | 1) {
      date.setSeconds(date.getSeconds() + add);

      const newDateTime = convertDateTime(date);

      setDateTime({
        obsId: undefined,
        date: newDateTime.date,
        time: newDateTime.time,
      });
    }

    updateDateTime(0);

    const interval = setInterval(() => {
      updateDateTime(1);
    }, 1000);

    return () => clearInterval(interval);
  }, [data, setDateTime]);

  if (!dateTime?.date || !dateTime?.time || dateTime.obsId !== undefined) {
    return null;
  }

  return (
    <Container>
      <DateBox>
        <TimeZone>KST</TimeZone>
        <SDate>{dateTime.date}</SDate>
      </DateBox>
      <Time>{dateTime.time}</Time>
    </Container>
  );
};

export default Clock;
